import { createFileRoute } from '@tanstack/react-router'
import { Analytics } from '../../pages'
import { RoleBasedPlaceholder } from '@/components/organisms/RoleBasedPlaceholder/RoleBasedPlaceholder'

export const Route = createFileRoute('/_layout/analytics')({
    component: Analytics,
    notFoundComponent: () => <RoleBasedPlaceholder />,
})
